import React from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import { useEffect, useState, useRef } from "react";
import "../pages/HomePage.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Details from "../components/DetailsList";
import {
  saveProperties,
  saveDraftProperties,
} from "../Redux/properties/PropertiesSlice";
import CreatePropertiesModal from "../components/CreatePropertiesModal";
import { productsByUser } from "../Redux/products/slice";
import MyProducts from "../components/MyProducts";
import MyContracts from "../components/MyContract";
import MenuPanel from "../components/MenuPanel";
import MyPersonalSpace from "../components/MyPersonalSpace";
import MyFarm from "../components/MyFarm";import MyNetwork from '../components/MyNetwork';import logo from '../assets/Logo.png';
import { createStyles, Navbar, Group, Code, getStylesRef, rem } from '@mantine/core';
import {
  IconBellRinging,
  IconFingerprint,
  IconKey,
  IconCirclePlus,
  Icon2fa,
  IconDatabaseImport,
  IconReceipt2,
  IconSwitchHorizontal,
  IconLogout,
  IconId,
  IconBuildingCottage,
  IconChevronDown,
  IconChevronRight,
  IconInfoCircle,
  IconCoin,
  IconFolder,
  IconHelp,
  IconNetwork
} from '@tabler/icons-react';
import { MantineLogo } from '@mantine/ds';
import Footer from "../components/Footer";
import SecondFooter from "../components/SecondFooter";
import { Select } from '@mantine/core';
import { logout, setShowLogin } from "../Redux/user/slice";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastProperties } from '../utils/constants/toastProperties';
import { setLanguage } from "../Redux/languageSlice";
import { isAuthenticated } from "../utils/tokenValidator";

import { IntlProvider, FormattedMessage, useIntl } from "react-intl";
import GuidedTour from "../components/GuidedTour";
import axios from "axios";
import { BASE_URL } from "../Redux/apiConfig";

const useStyles = createStyles((theme) => ({
  
  header: {
    paddingBottom: theme.spacing.md,
    marginBottom: `calc(${theme.spacing.md} * 0)`,
    borderBottom: `${rem(1)} solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]
    }`,
  },

  footer: {
    paddingTop: theme.spacing.md,
    marginTop: theme.spacing.md,
    borderTop: `${rem(1)} solid ${
      theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[2]
    }`,
  },

  link: {
    ...theme.fn.focusStyles(),
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    fontSize: theme.fontSizes.sm,
    color: theme.colorScheme === 'dark' ? theme.colors.dark[1] : theme.colors.gray[7],
    padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
    borderRadius: theme.radius.sm,
    fontWeight: 500,

    '&:hover': {
      backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[6] : theme.colors.gray[0],
      color: theme.colorScheme === 'dark' ? theme.white : theme.black,

      [`& .${getStylesRef('icon')}`]: {
        color: theme.colorScheme === 'dark' ? theme.white : theme.black,
      },
    },
  },

  linkIcon: {
    ref: getStylesRef('icon'),
    color: theme.colorScheme === 'dark' ? theme.colors.dark[2] : theme.colors.gray[6],
    marginRight: theme.spacing.sm,
  },

  linkActive: {
    '&, &:hover': {
      backgroundColor: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).background,
      color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color,
      [`& .${getStylesRef('icon')}`]: {
        color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color,
      },
    },
  }
}));

const data = [
  { link: '', label: <FormattedMessage id="mylist.navbar.products" />, icon: IconDatabaseImport, id: "myproducts"  },
  { link: '', label: <FormattedMessage id="mylist.navbar.cart" />, icon: IconReceipt2, id: "mycontracts" },
  // { link: '', label: <FormattedMessage id="mylist.navbar.newLot" />, icon: IconCirclePlus, id: "createnew" },
  { 
    link: '', 
    label: <FormattedMessage id="mylist.navbar.userSettings" />, 
    icon: IconId, 
    id: "mypersonalspace",
    children: [
      { label: <FormattedMessage id="tabs.userInfo" defaultMessage="User Information" />, icon: IconInfoCircle, id: "mypersonalspace-userInfo" },
      { label: <FormattedMessage id="tabs.profilePresentation" defaultMessage="Profile Presentation" />, icon: IconInfoCircle, id: "mypersonalspace-profilePresentation" },
      { label: <FormattedMessage id="tabs.files" defaultMessage="Files" />, icon: IconFolder, id: "mypersonalspace-files" },
    ]
  },
  { link: '', label: <FormattedMessage id="mylist.navbar.myFarm" />, icon: IconBuildingCottage, id: "myfarm" },
  { link: '', label: <FormattedMessage id="mylist.navbar.myNetwork" defaultMessage="My Network" />, icon: IconNetwork, id: "mynetwork", delegatedOnly: true },
];

const MyList = () => {
  const intl = useIntl();
  const [menu, setMenu] = useState([]);
  const props = useSelector((state) => state.properties);
  const prodStore = useSelector((state) => state.products);
  const { userInfo } = useSelector((state) => state.user);
  const currentComp = localStorage.getItem('comp');
  const [initialLoad, setInitialLoad] = useState(true);
  const [hasManagedAccounts, setHasManagedAccounts] = useState(false);

  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [topContentHeight, setTopContentHeight] = useState(0);
  
  const topContentRef = useRef(null);

  const { classes, cx } = useStyles();
  const [active, setActive] = useState('myproducts');
  const [expanded, setExpanded] = useState({ mypersonalspace: false });
  const [subSection, setSubSection] = useState('userInfo');

  // Workspace Tour State
  const [runTour, setRunTour] = useState(false);
  const tourWasRunning = useRef(false);

  // Save tourCompleted whenever tour goes from running -> stopped
  useEffect(() => {
    if (runTour) {
      tourWasRunning.current = true;
    } else if (tourWasRunning.current) {
      tourWasRunning.current = false;
      const userinfo = JSON.parse(localStorage.getItem('userinfo'));
      if (!userinfo?.accountId) return;
      const authToken = localStorage.getItem('authToken');
      // GET existing profile, merge tourCompleted, POST full object back
      fetch(`${BASE_URL}/api/profile/${userinfo.accountId}`)
        .then(res => res.json())
        .then(existingProfile => {
          const updatedProfile = { ...existingProfile, tourCompleted: true };
          return fetch(`${BASE_URL}/api/profile/${userinfo.accountId}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${authToken}`,
              'apikey': 'abc123'
            },
            body: JSON.stringify(updatedProfile)
          });
        })
        .then(() => console.log('tourCompleted saved'))
        .catch(err => console.error('tourCompleted save failed', err));
    }
  }, [runTour]);

  const navigate = useNavigate(); 
  const selectedLanguage = useSelector((state) => state.language);

  // Check if this user manages any accounts
  useEffect(() => {
    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    if (!userinfo?.accountId) return;
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}/api/managed/profiles?managerAccountId=${userinfo.accountId}`, {
      headers: { Authorization: `Bearer ${token}`, apikey: 'abc123' }
    })
      .then(r => r.ok ? r.json() : { result: [] })
      .then(d => setHasManagedAccounts((d.result || []).length > 0))
      .catch(() => {});
  }, []);

  const handleMenuClick = (item, isChild = false, parentId = null) => {
    if (item.children && !isChild) {
      const willBeExpanded = !expanded[item.id];
      setExpanded(prev => ({ ...prev, [item.id]: willBeExpanded }));
      setActive(item.id);
      localStorage.setItem('comp', item.id);
      if (willBeExpanded) {
        setSubSection(item.children[0].id.split('-')[1]);
      }
    } else {
      setActive(parentId || item.id);
      localStorage.setItem('comp', parentId || item.id);
      if (isChild) {
        setSubSection(item.id.split('-')[1]);
      }
      
      if (item.id === 'createnew') {
        setModal(true);
        setInitialLoad(false);
      } else {
        setModal(false);
      }
    }
  };
  
  useEffect(() => {
    const menu = data.map((item) => ({
      ...item,
      active: item.id === active,
    }));
  
    if (!initialLoad && currentComp === 'createnew') {
      setModal(true);
    } else {
      setModal(false);
    }
    
    // Auto-expand User Settings if it's the active component
    if (active === 'mypersonalspace' && !expanded.mypersonalspace) {
      setExpanded(prev => ({ ...prev, mypersonalspace: true }));
    }
  
    // Update the menu state
    setMenu(menu);
  }, [active, currentComp, initialLoad]);  
  
  const dispatch = useDispatch();

  // Check token validity on component mount
  useEffect(() => {
    if (!isAuthenticated()) {
      console.warn('Token expired or invalid - logging out user');
      
      // Show toast notification
      toast.error(<FormattedMessage id="toast.sessionexpired" />, ToastProperties);
      
      // Only clear auth-related keys to preserve other persisted data (e.g. cookieConsent)
      localStorage.removeItem('authToken');
      localStorage.removeItem('userLogged');
      localStorage.removeItem('userinfo');
      
      // Dispatch logout
      dispatch(logout());
      
      // Redirect to home after a short delay
      setTimeout(() => {
        navigate('/');
      }, 1000);
    }
  }, [dispatch, navigate]);

  const [modal, setModal] = useState(false);

  const onSave = (obj, cb) => {
    try {
      dispatch(saveProperties({ payload: obj, cb }));

    } catch (error) {
      // Handle errors from the save operation
    
      // Show error toast
      showToast('error', 'Error saving product');
    }

  };

  const onDraftSave = (obj, cb) => {
    try {
      dispatch(saveDraftProperties({ payload: obj, cb }));

    } catch (error) {
      // Handle errors from the save operation
    
      // Show error toast
      showToast('error', 'Error saving product draft');
    }
  };

  const handleLogout = () => {
    dispatch(logout());
    localStorage.removeItem('userLogged');
    localStorage.removeItem('userinfo');
    // Preserve tour completion status on logout
    // localStorage.removeItem('vertoWorkspaceTourCompleted'); // Keep this

    dispatch(setLanguage(selectedLanguage));

    if (window.location.pathname === '/my-list') {
      navigate('/');
    }
  }; 

  const comp = localStorage.getItem('comp');

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    
    window.addEventListener('resize', handleResize);
    
    if (topContentRef.current) {
      setTopContentHeight(topContentRef.current.offsetHeight);
    }
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []); 
  
  useEffect(() => {
    if (topContentRef.current) {
      setTopContentHeight(topContentRef.current.offsetHeight);
    }
  }, [data, active]); 

  // Expand Personal Space when tour starts
  useEffect(() => {
    if (runTour) {
      setExpanded(prev => ({ ...prev, mypersonalspace: true }));
    }
  }, [runTour]);

  // Check workspace tour completion status from backend
  useEffect(() => {
    const checkTourStatus = async () => {
      try {
        const userinfo = JSON.parse(localStorage.getItem('userinfo'));
        if (!userinfo?.accountId) return;

        const response = await axios.get(`${BASE_URL}/api/profile/${userinfo.accountId}`);

        if (response.data.tourCompleted) return;

        // tourCompleted not set — start the tour
        setTimeout(() => {
          const allElementsExist = ['myproducts','mycontracts','mypersonalspace','myfarm']
            .every(id => document.querySelector(`[data-tour-id="${id}"]`) !== null);
          if (allElementsExist) setRunTour(true);
        }, 2000);

      } catch (error) {
        console.error('checkTourStatus error:', error?.response?.status, error?.message);
      }
    };

    checkTourStatus();
  }, [userInfo]);

  const handleTourEnd = () => {
    setRunTour(false);
  };

  // Define workspace-specific tour steps
  const workspaceTourSteps = [
    {
      target: 'body',
      content: intl.formatMessage({ id: 'tour.workspace.welcome.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.welcome.title' }),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="myproducts"]',
      content: intl.formatMessage({ id: 'tour.workspace.products.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.products.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="mycontracts"]',
      content: intl.formatMessage({ id: 'tour.workspace.contracts.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.contracts.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="mypersonalspace"]',
      content: intl.formatMessage({ id: 'tour.workspace.personalspace.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.personalspace.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="mypersonalspace-userInfo"]',
      content: intl.formatMessage({ id: 'tour.workspace.personalspace.userinfo.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.personalspace.userinfo.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="mypersonalspace-profilePresentation"]',
      content: intl.formatMessage({ id: 'tour.workspace.personalspace.profile.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.personalspace.profile.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="mypersonalspace-files"]',
      content: intl.formatMessage({ id: 'tour.workspace.personalspace.files.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.personalspace.files.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: '[data-tour-id="myfarm"]',
      content: intl.formatMessage({ id: 'tour.workspace.farm.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.farm.title' }),
      placement: 'right',
      disableBeacon: true,
    },
    {
      target: 'body',
      content: intl.formatMessage({ id: 'tour.workspace.end.content' }),
      title: intl.formatMessage({ id: 'tour.workspace.end.title' }),
      placement: 'center',
      disableBeacon: true,
    },
  ];

  
  // Account for footer height (~80px) and padding
  const footerMargin = Math.max(0, windowHeight - topContentHeight + 60);

  // Determine which component to render based on the value of 'comp'
  let pageToRender;
  if (comp === 'mycontracts') {
    pageToRender = <MyContracts />;
  } else if (comp === 'mypersonalspace') {
    pageToRender = <MyPersonalSpace activeTab={subSection} onTabChange={setSubSection} />;
  } else if (comp === 'myfarm') {
    pageToRender = <MyFarm />;
  } else if (comp === 'mynetwork') {
    pageToRender = <MyNetwork />;
  } else {
    pageToRender = <MyProducts />;
  }

  useEffect(() => {
    setActive(comp);
  }, [comp]);

  const showToast = (type, message) => {
    // Use the toast function to display the appropriate toast message
    if (type === 'success') {
      toast.success(message, {
        ...ToastProperties
      });
    } else if (type === 'error') {
      toast.error(message, {
        ...ToastProperties
      });
    }
  };  

  return (
    <>
      {/* <MenuPanel /> */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={props.fetching || prodStore.fetching}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <nav className={classes.navbar} style={{display: 'flex', 
          flexDirection: 'column',
          minHeight: '100vh',
          }}>
        <div className={classes.navbarMain} style={{ display: 'flex', flex: '1',
                minHeight: '100vh',
                position: 'relative'
                }}>
          {/* Left Content */}
          <div style={{ 
            width: '250px',  
            borderRight: '1px solid #ccc',
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            position: 'sticky',
            top: 0,
            flexShrink: 0,
            overflowY: 'hidden',
          }}>
          {/* Top Content */}
          <div style={{ flex: '1', overflowY: 'auto', padding: '1rem' }}>
            <Group className={classes.header} position="apart" style={{ maxHeight: '50px', marginBottom: '1rem'}}>
              <img src={logo} alt="Logo" height={28} style={{ maxHeight: '28px', width: 'auto', objectFit: 'contain' }} />
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <button
                  onClick={() => setRunTour(true)}
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#009688',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    borderRadius: '4px',
                    transition: 'background-color 0.2s',
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 150, 136, 0.1)'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                  title="Start Workspace Tour"
                >
                  <IconHelp size={20} />
                </button>
                <Code sx={{ fontWeight: 700 }}>v1.0.0</Code>
              </div>
            </Group>
            
            {data.filter(item => !item.delegatedOnly || hasManagedAccounts).map((item) => (
              <React.Fragment key={item.id}>
                <a
                  className={cx(classes.link, { [classes.linkActive]: item.id === active })}
                  href={item.link}
                  data-tour-id={item.id}
                  onClick={(event) => {
                    event.preventDefault();
                    handleMenuClick(item);
                  }}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <item.icon className={classes.linkIcon} stroke={1.5} />
                    <span>{item.label}</span>
                  </div>
                  {item.children && (
                    expanded[item.id] ? <IconChevronDown size={16} /> : <IconChevronRight size={16} />
                  )}
                </a>
                {item.children && expanded[item.id] && (
                  <>
                    {item.children.map((child) => (
                      <a
                        key={child.id}
                        data-tour-id={child.id}
                        className={cx(classes.link, { [classes.linkActive]: subSection === child.id.split('-')[1] && active === item.id })}
                        href=""
                        onClick={(event) => {
                          event.preventDefault();
                          handleMenuClick(child, true, item.id);
                        }}
                        style={{ fontSize: '0.9rem', paddingLeft: '2rem' }}
                      >
                        <child.icon className={classes.linkIcon} stroke={1.5} size={18} />
                        <span>{child.label}</span>
                      </a>
                    ))}
                  </>
                )}
              </React.Fragment>
            ))}
          </div>
              {/* Bottom Content */}
              <div style={{ 
                    padding: '1rem',
                    borderTop: '1px solid #eee',
                    flexShrink: 0,
               }}>
                <a href="#" className={classes.link} onClick={(event) => {
                  event.preventDefault();
                  handleLogout();
                }}>
                  <IconSwitchHorizontal className={classes.linkIcon} stroke={1.5} />
                  <span><FormattedMessage id="button.changeAcct" /></span>
                </a>
                <a href="#" className={classes.link} onClick={(event) => {
                  event.preventDefault();
                  handleLogout();
                }}>
                  <IconLogout className={classes.linkIcon} stroke={1.5} />
                  <span><FormattedMessage id="button.logout" /></span>
                </a>
              </div>
          </div>
          {/* Right Content */}
          <div style={{ flex: '1', 
              padding: '1rem', 
              // overflowY: 'auto'
              position: 'relative' // Added for proper positioning
              }}>
            <div style={{ 
                padding: '.1rem', 
                borderRadius: '4px',
                position: 'relative', // Ensure proper stacking context
                zIndex: 1 // Make sure map is above other elements
              }}>
              {pageToRender}
            </div>
          </div>
        </div>
      </nav>
      <CreatePropertiesModal
        modal={modal}
        toggle={() => setModal(false)}
        onSave={(obj, cb) => onSave(obj, cb)}
        onDraftSave={(obj, cb) => onDraftSave(obj, cb)}
      />
      <GuidedTour 
        runTour={runTour} 
        onTourEnd={handleTourEnd}
        steps={workspaceTourSteps}
      />
      {/* <SecondFooter />
      <Footer /> */}
    </>
  );
};

export default MyList;